import React from 'react';
import RecordSourceWrapperIcon from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/components/RecordSourceWrapperIcon';
import { RECORD_SOURCE_ICON_SIZE } from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/constant/recordSourceIconSize';

const RecommendationIcon: React.FC = () => {
  return (
    <RecordSourceWrapperIcon className="bg-teal-40">
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width={RECORD_SOURCE_ICON_SIZE.width}
        height={RECORD_SOURCE_ICON_SIZE.height}
        viewBox="0 0 13 13"
        fill="none"
      >
        <path
          d="M11.0153 9.97331L9.97363 11.015L7.29134 8.33268V7.29102H8.33301L11.0153 9.97331ZM11.9007 10.8587L11.3799 10.3379L10.3382 11.3796L10.859 11.9004C10.958 11.9993 11.1247 11.9993 11.2288 11.9004L11.9007 11.2285C12.0049 11.1243 12.0049 10.9629 11.9007 10.8587Z"
          fill="white"
        />
        <path
          d="M7.90072 10.416H3.12467V2.08268H6.85905L9.37467 4.59831V6.85872L10.4163 7.90039V4.16602L7.29134 1.04102H3.12467C2.55176 1.04102 2.08301 1.50977 2.08301 2.08268V10.416C2.08301 10.9889 2.55176 11.4577 3.12467 11.4577H8.94238L7.90072 10.416Z"
          fill="white"
        />
        <path
          d="M9.63509 4.68685H6.77051V1.82227L9.63509 4.68685Z"
          fill="white"
        />
      </svg>
    </RecordSourceWrapperIcon>
  );
};

export default RecommendationIcon;
